exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._-test-app-components-App-App__root__htqzO {\n  text-align: center;\n}\n\n._-test-app-components-App-App__header__gaZK5 {\n  background-color: #222;\n  padding: 10px;\n  color: white;\n  font-size: 20pt;\n}\n\n._-test-app-components-App-App__intro__1ppWy {\n  font-size: 15pt;\n}\n\n", ""]);

// exports
exports.locals = {
	"root": "_-test-app-components-App-App__root__htqzO",
	"header": "_-test-app-components-App-App__header__gaZK5",
	"intro": "_-test-app-components-App-App__intro__1ppWy"
};